/* Nevalyn PDP v2: gedrag van het koopblok (sections/sana-v2-buybox.liquid).
   Leest #SanaV2Cfg (teksten en routes) en #SanaVMapG (varianten).
   De variantkeuze en het toevoegen aan de winkelwagen zijn overgenomen uit sana-buybox-gifts. */
(function () {
  'use strict';

  var root = document.getElementById('SanaV2Buybox');
  var form = document.getElementById('SanaBuyFormG');
  if (!root || !form) return;

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  var cfg = readJson('SanaV2Cfg');
  var vMap = readJson('SanaVMapG');
  var X = String.fromCharCode(215);
  var SCROLL_OFFSET = 96;
  var mqDesktop = window.matchMedia('(min-width: 900px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function smooth() { return mqReduce.matches ? 'auto' : 'smooth'; }

  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, y), behavior: smooth() });
  }

  /* ---------- Sets, maat en variant ---------- */

  var idInput = form.querySelector('input[name="id"]');
  var atcBtn = form.querySelector('.sana-bb-atc');
  var tierRadios = all('input[name="sana-tier-g"]', root);
  var sizeBox = root.querySelector('[data-v2-size]');
  var sizeHead = root.querySelector('[data-v2-size-head]');
  var sizeUni = root.querySelector('[data-v2-size-uni]');
  var sizePer = root.querySelector('[data-v2-size-per]');
  var sizeBtns = all('.v2-size-btn', root);
  var perToggle = root.querySelector('[data-v2-toggle-per]');
  var currentTier = '1';
  var perMode = false;

  var sticky = document.getElementById('SanaBBStickyG');
  var stickyTitle = sticky ? sticky.querySelector('[data-v2-sticky-title]') : null;
  var stickySub = sticky ? sticky.querySelector('[data-v2-sticky-sub]') : null;
  var stickyBtn = sticky ? sticky.querySelector('[data-v2-sticky-btn]') : null;
  var stickyState = '';
  var chosen = {
    bundle: stickyTitle ? stickyTitle.textContent : '',
    price: stickySub ? stickySub.textContent : '',
    avail: atcBtn ? !atcBtn.disabled : true
  };

  function tierRadio(t) {
    return root.querySelector('input[name="sana-tier-g"][data-tier="' + t + '"]');
  }
  function panelChecked(t) {
    return all('.sana-bb-ph[data-ph="' + t + '"] input:checked', root);
  }

  function compLabel(t) {
    var rows = panelChecked(t);
    var n = rows.length;
    if (n === 0) return '';
    if (n === 1) return rows[0].value;
    var nH = 0;
    rows.forEach(function (r) { if (r.value === 'High') nH++; });
    if (nH === 0) return n + X + ' Standard';
    if (nH === n) return n + X + ' High';
    return (n - nH) + X + ' Standard, ' + nH + X + ' High';
  }

  function currentVariant() {
    var r = tierRadio(currentTier);
    if (!r) return null;
    return vMap[r.dataset.bundle + '|' + compLabel(currentTier)] || null;
  }

  function firstSize(t) {
    var rows = panelChecked(t);
    return rows.length ? rows[0].value : 'Standard';
  }
  function isUniform(t) {
    var rows = panelChecked(t);
    for (var i = 1; i < rows.length; i++) {
      if (rows[i].value !== rows[0].value) return false;
    }
    return true;
  }
  function setAllSizes(t, size) {
    all('.sana-bb-ph[data-ph="' + t + '"] input', root).forEach(function (inp) {
      inp.checked = inp.value === size;
    });
  }
  function syncUniButtons(size) {
    sizeBtns.forEach(function (b) {
      var on = b.dataset.size === size;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function showPanel(t) {
    all('.sana-bb-ph', root).forEach(function (p) { p.hidden = p.dataset.ph !== t; });
  }
  function setMode(per) {
    perMode = per;
    if (sizeUni) sizeUni.hidden = per;
    if (sizePer) sizePer.hidden = !per;
    if (perToggle) perToggle.textContent = per ? cfg.sameLabel : cfg.perLabel;
  }
  function updateHead() {
    var r = tierRadio(currentTier);
    var count = r ? parseInt(r.dataset.count, 10) || 1 : 1;
    if (sizeHead && cfg.sizeHead) sizeHead.textContent = cfg.sizeHead[Math.min(count, 3) - 1] || cfg.sizeHead[0];
    if (perToggle) perToggle.hidden = count < 2;
  }

  function paintSticky() {
    if (!sticky) return;
    var before = stickyState === 'before';
    if (stickyTitle) stickyTitle.textContent = before ? (cfg.fromTitle || '') : chosen.bundle;
    if (stickySub) stickySub.textContent = before ? (cfg.fromSub || '') : chosen.price;
    if (stickyBtn) stickyBtn.disabled = before ? false : !chosen.avail;
  }

  function applyVariant() {
    var r = tierRadio(currentTier);
    tierRadios.forEach(function (inp) {
      var card = inp.closest('.v2-set');
      if (card) card.classList.toggle('is-checked', inp.checked);
    });
    var v = currentVariant();
    if (!v || !r) return;
    if (idInput) idInput.value = v.id;
    chosen.bundle = r.dataset.bundle;
    chosen.price = v.price;
    chosen.avail = !!v.avail;
    all('[data-v2-gold]').forEach(function (b) {
      var label = b.querySelector('[data-v2-atc-label]');
      var div = b.querySelector('[data-v2-atc-div]');
      var price = b.querySelector('[data-v2-atc-price]');
      b.disabled = !v.avail;
      if (label) label.textContent = v.avail ? (cfg.atcLabel || label.textContent) : cfg.soldOut;
      if (price) { price.textContent = v.price; price.hidden = !v.avail; }
      if (div) div.hidden = !v.avail;
    });
    paintSticky();
  }

  /* Leest de stand uit de pagina zelf. Na terug-navigatie kan de browser andere radio's hebben hersteld dan de server tekende. */
  function syncFromDom() {
    var checked = root.querySelector('input[name="sana-tier-g"]:checked');
    if (checked) currentTier = checked.dataset.tier;
    showPanel(currentTier);
    if (isUniform(currentTier)) {
      setMode(false);
      syncUniButtons(firstSize(currentTier));
    } else {
      setMode(true);
    }
    updateHead();
    applyVariant();
  }

  tierRadios.forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      var size = firstSize(currentTier);
      currentTier = r.dataset.tier;
      setAllSizes(currentTier, size);
      showPanel(currentTier);
      setMode(false);
      syncUniButtons(size);
      updateHead();
      applyVariant();
    });
  });

  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      setAllSizes(currentTier, b.dataset.size);
      syncUniButtons(b.dataset.size);
      applyVariant();
    });
  });

  all('.sana-bb-ph input', root).forEach(function (inp) {
    inp.addEventListener('change', applyVariant);
  });

  if (perToggle) {
    perToggle.addEventListener('click', function () {
      if (perMode) {
        var size = firstSize(currentTier);
        setAllSizes(currentTier, size);
        syncUniButtons(size);
        setMode(false);
        applyVariant();
      } else {
        setMode(true);
      }
    });
  }

  /* ---------- Sticky balk ---------- */

  function stickyWanted() {
    if (!atcBtn) return 'hidden';
    var r = atcBtn.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return 'hidden';
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.bottom <= 0) return 'after';
    if (r.top >= vh && cfg.stickyFromLoad && !mqDesktop.matches) return 'before';
    return 'hidden';
  }

  function updateSticky() {
    if (!sticky) return;
    var want = stickyWanted();
    if (want === stickyState) return;
    stickyState = want;
    var show = want !== 'hidden';
    if (show) {
      sticky.setAttribute('data-state', want);
      paintSticky();
    }
    sticky.classList.toggle('is-show', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  var stickyTick = false;
  function queueSticky() {
    if (stickyTick) return;
    stickyTick = true;
    window.requestAnimationFrame(function () {
      stickyTick = false;
      updateSticky();
    });
  }

  if (sticky) {
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky);
    window.addEventListener('load', queueSticky);
    if ('IntersectionObserver' in window && atcBtn) {
      new IntersectionObserver(queueSticky, { threshold: 0 }).observe(atcBtn);
    }
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      if (stickyState !== 'before') return;
      e.preventDefault();
      scrollToEl(document.getElementById('SanaBuyForm'));
    });
  }

  /* ---------- Galerij ---------- */

  var track = root.querySelector('[data-v2-track]');
  var slides = all('[data-v2-slide]', root);
  var thumbsRow = root.querySelector('[data-v2-thumbs]');
  var thumbs = all('[data-v2-thumb]', root);
  var activeSlide = 0;
  var lockTarget = -1;
  var lockTimer = null;

  function slideLeft(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }

  function nearestSlide() {
    var x = track.scrollLeft;
    var best = 0;
    var bestD = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var d = Math.abs(slideLeft(i) - x);
      if (d < bestD) { bestD = d; best = i; }
    }
    return best;
  }

  function markSlide(i) {
    if (i === activeSlide) return;
    var vid = slides[activeSlide] ? slides[activeSlide].querySelector('video') : null;
    if (vid && !vid.paused) vid.pause();
    activeSlide = i;
    thumbs.forEach(function (t, k) {
      var on = k === i;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var t = thumbs[i];
    if (thumbsRow && t) {
      var left = t.offsetLeft - thumbs[0].offsetLeft;
      var right = left + t.offsetWidth;
      var view = thumbsRow.clientWidth - 8;
      if (left < thumbsRow.scrollLeft) thumbsRow.scrollTo({ left: left, behavior: smooth() });
      else if (right > thumbsRow.scrollLeft + view) thumbsRow.scrollTo({ left: right - view, behavior: smooth() });
    }
  }

  function goTo(i) {
    if (!track || !slides[i]) return;
    lockTarget = i;
    window.clearTimeout(lockTimer);
    lockTimer = window.setTimeout(function () { lockTarget = -1; }, 1200);
    markSlide(i);
    track.scrollTo({ left: slideLeft(i), behavior: smooth() });
  }

  if (track && slides.length > 1) {
    track.addEventListener('scroll', function () {
      if (lockTarget >= 0) {
        if (Math.abs(track.scrollLeft - slideLeft(lockTarget)) < 2) lockTarget = -1;
        return;
      }
      markSlide(nearestSlide());
    }, { passive: true });

    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { lockTarget = -1; }, { passive: true });
    });

    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var n = activeSlide + (e.key === 'ArrowRight' ? 1 : -1);
      if (n < 0 || n >= slides.length) return;
      e.preventDefault();
      goTo(n);
    });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    var resizeTick = false;
    window.addEventListener('resize', function () {
      if (resizeTick) return;
      resizeTick = true;
      window.requestAnimationFrame(function () {
        resizeTick = false;
        track.scrollLeft = slideLeft(activeSlide);
      });
    });
  }

  /* ---------- Maatgids ---------- */

  var dialog = document.getElementById('SanaV2SizeDialog');
  var sizeOpener = null;

  function afterSizesClosed() {
    document.body.classList.remove('overflow-hidden');
    if (sizeOpener && typeof sizeOpener.focus === 'function') sizeOpener.focus();
    sizeOpener = null;
  }

  function closeSizes() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      if (dialog.open) dialog.close();
    } else {
      dialog.removeAttribute('open');
      afterSizesClosed();
    }
  }

  function openSizes(opener) {
    var section = document.getElementById('sizes');
    if (section && mqDesktop.matches) {
      scrollToEl(section);
      return;
    }
    if (!dialog) return;
    sizeOpener = opener || null;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.body.classList.add('overflow-hidden');
  }

  if (dialog) {
    dialog.addEventListener('close', afterSizesClosed);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeSizes();
    });
    all('[data-v2-close-sizes]', dialog).forEach(function (b) {
      b.addEventListener('click', closeSizes);
    });
  }

  /* ---------- Klikken elders op de pagina: maatgids, reviews, naar het koopblok ---------- */

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;

    var opener = el.closest('[data-v2-open-sizes]');
    if (opener) {
      e.preventDefault();
      openSizes(opener);
      return;
    }

    var toReviews = el.closest('[data-v2-to-reviews]');
    if (toReviews) {
      var target = document.getElementById('reviews') || document.querySelector('.shopify-section[id$="__reviews_loox"]');
      if (target) {
        e.preventDefault();
        scrollToEl(target);
      }
      return;
    }

    var toBuy = el.closest('a[href="#SanaBuyForm"], [data-v2-scroll-buy]');
    if (toBuy) {
      var anchor = document.getElementById('SanaBuyForm');
      if (!anchor) return;
      e.preventDefault();
      scrollToEl(anchor);
      try { window.history.replaceState(null, '', '#SanaBuyForm'); } catch (err) {}
    }
  });

  /* ---------- Toevoegen aan de winkelwagen ---------- */

  var busy = false;

  function setBusy(on) {
    busy = on;
    all('[data-v2-gold]').forEach(function (b) {
      if (on) b.setAttribute('aria-busy', 'true');
      else b.removeAttribute('aria-busy');
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);

    var item = { id: parseInt(idInput.value, 10), quantity: 1 };
    var r = tierRadio(currentTier);
    if (r && r.dataset.incl) {
      item.properties = {};
      item.properties[cfg.inclFreeKey || 'Included free'] = r.dataset.incl;
    }
    var cartAddUrl = cfg.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add';
    var cartUrl = cfg.cartUrl || (window.routes && window.routes.cart_url) || '/cart';
    var opener = document.activeElement;

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Add to cart failed');
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state.sections) {
          try {
            cartDrawer.classList.remove('is-empty');
            var inner = cartDrawer.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            if (typeof cartDrawer.setActiveElement === 'function' && opener) cartDrawer.setActiveElement(opener);
            cartDrawer.renderContents(state);
            setBusy(false);
          } catch (err) {
            window.location.href = cartUrl;
          }
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(function () {
        setBusy(false);
        window.location.href = cartUrl;
      });
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    setBusy(false);
    syncFromDom();
    stickyState = '';
    updateSticky();
  });

  syncFromDom();
  updateSticky();
})();
